module.exports = __webpack_public_path__ + "img/D202007_2.24c82f84.jpg";